export enum ModalText {
  OTPEmail = "An OTP has been sent to your Email to validate your request.",
  OTPSMS = "An OTP has been sent to your SMS to validate your request.",
}

export enum ModalHeader {
  SecretQuestion = "Secret Question",
  OTP = "One Time Pin",
}

export enum ModalFooter {
  ResendCode = "Didn't receive a code?",
}

export enum ModalType {
  OTP = "OTP",
  ForgetPassword = "ForgetPassword",
}
